import React from "react";
import { Link } from "react-router-dom";
import { buildBarcodeHistoryPath } from "../controls/TraceableBarcode";

export const buildBarcodeHistoryUrl = buildBarcodeHistoryPath;

export default function BarcodeHistoryLink({ barcode, className = "" }) {
  if (!barcode) return null;

  return (
    <Link
      to={buildBarcodeHistoryUrl(barcode)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`View lifecycle history for barcode ${barcode}`}
      className={`ml-2 inline-flex items-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 ${className}`.trim()}
    >
      History
    </Link>
  );
}
